import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <div className="relative min-h-screen bg-[#0B0F19] flex items-center justify-center px-4">
      <div className="absolute inset-0 canvas-dots opacity-40" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-xl">
        <h1 className="mb-2 text-2xl font-bold text-white font-display">Forgot password</h1>
        {sent ? (
          <p data-testid="forgot-confirmation" className="text-slate-300">
            If that email is registered, a reset link has been sent. Check your inbox ✦
          </p>
        ) : (
          <form onSubmit={submit}>
            <input
              data-testid="forgot-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@nexfy.in"
              className="mb-4 w-full rounded-xl border border-white/10 bg-white/10 px-4 py-3 text-white placeholder-slate-500 outline-none focus:border-violet-400"
            />
            <button data-testid="forgot-submit-button" type="submit"
              className="w-full rounded-xl bg-gradient-to-r from-violet-500 to-pink-500 py-3 font-bold text-white">
              Send reset link
            </button>
          </form>
        )}
        <Link to="/login" data-testid="back-to-login-link" className="mt-4 block text-center text-sm text-violet-300 hover:text-violet-200">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
